import {
  createContext,
  useEffect,
  useState,
  useContext as _useContext,
  useMemo,
  PropsWithChildren,
  FC,
} from 'react';

import cn from 'classnames';
import { useLocation } from 'react-router-dom';
import Menu from 'ui/partials/Menu';
import Profile from 'ui/partials/Profile';
import { useGetSubscription } from 'modules/account/settings/hooks';
import { useProvider } from 'utils/providers/Provider';
import { useAdminParams } from 'utils/helpers';

type APPWRAPPER_CONTEXT_PROPS = {
  state: {
    isPreview?: boolean;
    relativePath?: string;
    [key: string]: any;
  };
  dispatch?: React.Dispatch<React.SetStateAction<boolean>>;
};
export const AppWrapperContext = createContext<APPWRAPPER_CONTEXT_PROPS>({
  state: { isPreview: false },
});
// eslint-disable-next-line react-refresh/only-export-components
export const useAppWrapperContext = () => _useContext(AppWrapperContext);

type PROPS = FC<PropsWithChildren>;

export const AppElement: PROPS = ({ children }) => {
  const location = useLocation();
  const { data: subscription } = useGetSubscription();
  const {
    // TODO use state later for checking isOpenBanner
    // state,
    dispatch,
  } = useProvider();

  useEffect(() => {
    if (subscription?.isExpired) {
      dispatch?.({ type: 'toggleBanner', payload: true });
    }
  }, [subscription?.isExpired, dispatch, location]);

  return (
    <div className="relative">
      <div
        // className={cn('flex', state?.isOpenBanner ? 'pt-[118px]' : 'pt-[60px]')}
        className="sticky top-0 left-0 flex h-full"
      >
        <Menu />
        <div className="flex flex-col flex-1">
          <Profile />
          <div className={cn('content-wrapper', 'flex flex-1')}>
            <div className={cn(['bg-fill-primary', 'w-full overflow-y-auto'])}>
              <div className="h-full main-content">{children}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const AppWrapper: FC<PropsWithChildren> = ({ children }) => {
  const [isPreview, setIsPreview] = useState(false);
  const { accountId, accountUserId } = useAdminParams();

  const relativePath = useMemo(
    () =>
      isPreview
        ? `/preview/accounts/${accountId}/users/${accountUserId}/`
        : '/',
    [accountId, accountUserId, isPreview],
  );

  const value = useMemo(
    () => ({ state: { isPreview, relativePath }, dispatch: setIsPreview }),
    [isPreview, relativePath],
  );

  return (
    <AppWrapperContext.Provider value={value}>
      {!value.state.isPreview ? <AppElement>{children}</AppElement> : children}
    </AppWrapperContext.Provider>
  );
};

export default AppWrapper;
